module.exports = __webpack_public_path__ + "static/media/icn-empty-state.854b0803.svg";